import React, { useState } from "react";

export default function FirmaEfimeraModal({ open, onClose, onConfirm }) {
  const [cer, setCer] = useState(null);
  const [key, setKey] = useState(null);
  const [password, setPassword] = useState("");

  if (!open) return null;

  const ready = cer && key && password?.length > 0;

  return (
    <div style={backdrop}>
      <div style={modal}>
        <h3 style={{ marginBottom: 12 }}>Agregar e.firma</h3>

        <label>.cer (DER)</label>
        <input type="file" accept=".cer" onChange={(e)=>setCer(e.target.files?.[0]||null)} />

        <label style={{ marginTop: 8 }}>.key (DER)</label>
        <input type="file" accept=".key" onChange={(e)=>setKey(e.target.files?.[0]||null)} />

        <label style={{ marginTop: 8 }}>Contraseña</label>
        <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} />

        <div style={{ display:"flex", gap:8, marginTop:12 }}>
          <button onClick={onClose}>Cancelar</button>
          <button disabled={!ready} onClick={()=>onConfirm({ cer, key, password })}>
            Usar e.firma
          </button>
        </div>
      </div>
    </div>
  );
}

const backdrop = {
  position:"fixed", inset:0, background:"rgba(0,0,0,0.45)",
  display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000
};
const modal = {
  background:"#fff", borderRadius:8, padding:16, width:380,
  boxShadow:"0 10px 30px rgba(0,0,0,.2)", display:"flex", flexDirection:"column"
};
